
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/components/ui/sonner';
import { useAuth } from '@/contexts/AuthContext';
import { getStorageUrlWithCacheBuster } from '@/utils/storageUtils';

export function useUpdateProfile() {
  const [uploading, setUploading] = useState(false);
  const { user } = useAuth();
  
  const uploadAvatar = async (file: File) => {
    if (!user) return null;
    
    try {
      setUploading(true);
      
      // Создаем уникальное имя файла с расширением из оригинального файла
      const fileExt = file.name.split('.').pop();
      // Используем текущий timestamp для предотвращения коллизий имен файлов
      const timestamp = Date.now();
      const filePath = `${user.id}/avatar_${timestamp}.${fileExt}`;
      
      // Загружаем файл в storage
      const { error: uploadError } = await supabase.storage
        .from('avatars')
        .upload(filePath, file, { upsert: true });
        
      if (uploadError) {
        throw uploadError;
      }
      
      // Получаем публичный URL
      const { data: { publicUrl } } = supabase.storage
        .from('avatars')
        .getPublicUrl(filePath);
      
      // Используем проксированный URL с обходом кэша
      const finalUrl = getStorageUrlWithCacheBuster(publicUrl);
      
      // Обновляем профиль пользователя с новым URL аватара
      const { error: updateError } = await supabase
        .from('profiles')
        .update({ avatar: finalUrl })
        .eq('id', user.id);
      
      if (updateError) {
        // Пробуем обновить таблицу couriers, если profiles не сработал
        const { error: couriersUpdateError } = await supabase
          .from('couriers')
          .update({ avatar: finalUrl })
          .eq('id', user.id);
          
        if (couriersUpdateError) {
          throw couriersUpdateError;
        }
      }
      
      toast.success("Фотография профиля успешно обновлена");
      return finalUrl;
      
    } catch (error: any) {
      toast.error(`Ошибка при загрузке фото: ${error.message}`);
      console.error('Ошибка при загрузке аватара:', error);
      return null;
    } finally {
      setUploading(false);
    }
  };
  
  return { uploadAvatar, uploading };
}
